import useStateHelper from '@/views/shared/useStateHelper';

const reportDefault = {
  2: {dateType: 'APPL'},
  3: {dateType: 'APPL'},
  4: {dateType: 'APPL'},
  6: {month: new Date().getMonth() === 11 ? 0 : new Date().getMonth() + 2},
  8: {
    expiryFromYear: new Date().getFullYear(),
    expiryFromMonth: new Date().getMonth() + 1,
    expiryToYear: new Date().getFullYear(),
    expiryToMonth: new Date().getMonth() + 1,
  },
  10: {dateType: 'APPL'},
  11: {dateType: 'APPL'},
  12: {dateType: 'APPL'},
  13: {dateType: 'APPL'},
  14: {dateType: 'APPL'},
};

const handlers = {
  updateFormData(state, action) {
    const newState = action.data(state);

    if (state.reportType !== newState.reportType) {
      return {
        reportType: newState.reportType,
        includedTeam: newState.includedTeam,
        ...reportDefault[newState.reportType],
      };
    }

    return newState;
  },
};

const [ReportStateProvider, useReportCtx] = useStateHelper({handlers});
export {ReportStateProvider, useReportCtx};
